import React, {Component} from 'react';
import PropTypes from "prop-types";

import placeholderLarge from "../assets/images/placeholder-large.png";
import placeholderThumb from "../assets/images/placeholder-thumb.png";

import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/blur-up/ls.blur-up';

window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.expand = 10;
window.lazySizesConfig.expFactor = 1.5;

class ProgressiveImage extends Component {
  static propTypes = {
    image: PropTypes.object,
    size: PropTypes.string,
    className: PropTypes.string
  };

  render() {
    const { image, size, alt, className } = this.props;

    let classNames = ["lazyload progressive-image"];
    if (className) {
      classNames.push(this.props.className);
    } else {
      classNames.push('img-fluid full');
    }

    const placeholder = <img src={size === "thumb" ? placeholderThumb : placeholderLarge} alt={alt || "Untitled"} className={classNames.join(" ")} />;

    if (!image) {
      return placeholder;
    }

    if (image.image_type && image.image_type === "remote") {
      return (
        <div className={'progressive-image remote lazyload'} style={{ backgroundImage: `url("${placeholder}")` }} data-bg={image.url} />
      );
    }

    if (!image.urls) {
      return placeholder;
    }

    const url = size === "full" ? image.urls.url : image.urls[size || "large"].url;

    return (
      <img src={size === "thumb" ? placeholderThumb : placeholderLarge} data-src={url} alt={alt || "Untitled"} className={classNames.join(" ")} />
    );
  }
}

export default ProgressiveImage;